import apiService from '@services/base/apiService';
import { env } from '@configuration/env';
import {
  AntwoordenApi,
  ControleregelsApi,
  HoedanighedenApi,
  MappingVoertuigdataApi,
  ProductVragenApi,
  SbiCodesApi,
} from './api';

const baseUrl = env.VUE_APP_MANAGEMENT_BASE_URL;

export const productVragenApi = apiService.create(ProductVragenApi, baseUrl);
export const antwoordenApi = apiService.create(AntwoordenApi, baseUrl);
export const sbiCodesApi = apiService.create(SbiCodesApi, baseUrl);
export const hoedanighedenApi = apiService.create(HoedanighedenApi, baseUrl);
export const mappingVoertuigdataApi = apiService.create(MappingVoertuigdataApi, baseUrl);
export const acceptatieregelsApi = apiService.create(ControleregelsApi, baseUrl);
